// Dynamic image switcher for product cards
const handleDynamicImgs = document.querySelectorAll('.handleDynamicImg');

handleDynamicImgs.forEach((colorCircle) => {
    colorCircle.addEventListener('click', function () {
        const newImageUrl = this.getAttribute('data-img');
        const productCard = this.closest('.product-card-parent');
        const dynamicSrcImg = productCard.querySelector('.dynamicSrcImg img');

        // Quitar color-active de todos los hermanos del mismo grupo
        const siblings = this.parentElement.querySelectorAll('.handleDynamicImg');
        siblings.forEach(sibling => {
            sibling.classList.remove('color-active');
        });

        // Agregar color-active al que se hizo clic
        this.classList.add('color-active');

        if (dynamicSrcImg && newImageUrl) {
            dynamicSrcImg.classList.remove('fadeIn');
            dynamicSrcImg.offsetHeight;

            dynamicSrcImg.src = newImageUrl;
            dynamicSrcImg.classList.add('fadeIn');
        }
    });
});
// End Dynamic image switcher
